import { css } from "@emotion/css";
import { InlineMessage } from "@octopusdeploy/design-system-components";
import { OctoLink } from "@octopusdeploy/utilities";
interface SpaceUpsellMessageProps {
    licenseSerialNumber?: string;
}
export const SpaceUpsellMessageTestId = "space-upsell-message";
export const SpaceUpsellMessage = ({ licenseSerialNumber }: SpaceUpsellMessageProps) => {
    const upgradePlanLink = licenseSerialNumber ? OctoLink.Create(`plan-upgrade?serial=${licenseSerialNumber}`) : OctoLink.Create("ControlCenter");
    return (<div className={spaceUpsellMessageStyles} data-testid={SpaceUpsellMessageTestId}>
            <InlineMessage type={"upsell"} description={"Upgrade to access unlimited spaces."} action={{
            href: upgradePlanLink,
            label: "Upgrade",
            external: true,
        }}/>
        </div>);
};
const spaceUpsellMessageStyles = css({
    width: "100%",
});
